// generateChartData.js (MultiGrid / 2DGrid label fix)
const normKey = (v) => {
  if (v === null || v === undefined) return "__MISSING__";
  const s = String(v).trim();
  const cleaned = s.replace(/^0+([1-9])/, "$1").replace(/\.0+$/, "");
  return cleaned === "" ? "__MISSING__" : cleaned;
};

export default function generateChartData(originalDataRows, variableKey, selectedVar = {}) {
  if (!variableKey || !Array.isArray(originalDataRows) || originalDataRows.length === 0) {
    return [];
  }

  const allColumns = Object.keys(originalDataRows[0] || {});
  const prefix = variableKey.includes("r") ? variableKey.split("r")[0] : variableKey;
  const gridColumns = allColumns.filter((c) => c.startsWith(prefix + "r"));
  const isMultiGrid = gridColumns.length > 1;
  const result = [];

  // ------------------------------
  // CASE 1: MULTI-GRID
  // ------------------------------
  if (isMultiGrid) {
    const allCols = Object.keys(originalDataRows[0] || {});
    const prefixMatch = variableKey.match(/^(.*?r)\d+$/);
    const prefix = prefixMatch ? prefixMatch[1] : variableKey;
    const gridCols = allCols.filter(c => c.startsWith(prefix));

    // Overall base: respondents who answered ANY column
    const overallBase = originalDataRows.filter(row =>
      gridCols.some(col => row[col] !== null && row[col] !== undefined && row[col] !== "")
    ).length;

    // Build rowMap from selectedVar.Rows
    const rowMap = {};
    if (Array.isArray(selectedVar?.Rows)) {
      selectedVar.Rows.forEach(r => {
        const m = r.title.match(/^([A-Za-z0-9_]+r\d+)(.*)$/);
        if (m) {
          const colName = m[1];          // e.g., NETT_C12r1
          const label = m[2].trim();     // e.g., BRAND PERCEPTION & AWARENESS
          rowMap[colName] = label;
        }
      });
    }

    gridCols.forEach(col => {
      let count = 0;

      originalDataRows.forEach(row => {
        if (row[col] == 1) count++;
      });

      // --- Extract r-number e.g., r1 → 1 ---
      const match = col.match(/r(\d+)/);
      const index = match ? match[1] : null;

      // --- Find label from selectedVar.values ---
      let label = col;
      if (index && Array.isArray(selectedVar?.values)) {
        const found = selectedVar.values.find(v => String(v.value) === String(index));
        if (found) label = found.label;
      }

      result.push({
        name: label,
        value: count,
        percent: overallBase ? Number(((count / overallBase) * 100).toFixed(1)) : 0,
        base: overallBase,
        variable: variableKey.replace(/r\d+$/, "")
      });
    });
    return result;
  }




  // --------------- CATEGORICAL CASE ----------------
  let valuesArray = [];
  let valueLabels = {};
  if (Array.isArray(selectedVar)) {
    valuesArray = selectedVar;
    valueLabels = Object.fromEntries(selectedVar.map(v => [String(v.value).trim(), v.label]));
  } else {
    valuesArray = Array.isArray(selectedVar?.values) ? selectedVar.values : [];
    valueLabels = selectedVar?.valueLabels || {};
  }

  const getLabelForCode = (code) => {
    const k = normKey(code);
    if (valueLabels[k] !== undefined || valueLabels[Number(k)] !== undefined) {
      return String(valueLabels[k] ?? valueLabels[Number(k)]);
    }
    if (valuesArray.length) {
      const found = valuesArray.find((v) => {
        const candidate = v?.value ?? v?.index ?? v?.code ?? v?.Id ?? v?.Value;
        return normKey(candidate) === k;
      });
      if (found) return found.label ?? found.title ?? found.Name ?? String(found.value ?? found.index ?? k);
    }
    return k;
  };

  const countMap = {};
  let base = 0;
  originalDataRows.forEach((row) => {
    const raw = row[variableKey];
    if (raw === null || raw === undefined || raw === "") return;
    const k = normKey(raw);
    countMap[k] = (countMap[k] || 0) + 1;
    base++;
  });

  // Build result preserving valueLabels or valuesArray order
  const keys = valuesArray.length ? valuesArray.map(v => normKey(v.value ?? v.index ?? v.Id ?? v.Value)) : Object.keys(countMap);
  keys.forEach((k) => {
    if (!countMap[k]) return;
    const label = getLabelForCode(k);
    result.push({
      name: label,
      value: countMap[k],
      percent: base ? Number(((countMap[k] / base) * 100).toFixed(1)) : 0,
      base
    });
  });

  // Add remaining codes not in valuesArray
  Object.keys(countMap).forEach((c) => {
    if (keys.includes(c)) return;
    const label = getLabelForCode(c);
    result.push({
      name: label,
      value: countMap[c],
      percent: base ? Number(((countMap[c] / base) * 100).toFixed(1)) : 0,
      base
    });
  });

  return result;
}
  